import * as emailjs from "emailjs-com";
import React,{useEffect} from 'react';
import { useHistory } from 'react-router-dom';
import "./contactForm.scss";
import logo from "../../images/logo.png";


export default function ContactUs() {
    const history = useHistory();
    document.body.style.backgroundColor = "#F14D36";
    function sendEmail(e) {
        e.preventDefault();

    emailjs.sendForm('service_462tizg', 'template_itnu5a9', e.target, 'user_WTesdNlTHUiwnYeHFqMJI')
        .then((result) => {
            console.log(result.text);
            history.push("/")
        }, (error) => {
            console.log(error.text);
            history.push("/scv")
        });
        e.target.reset()
    }
 
   
    
   

    return(
        <div>
        <div className="imgo"> <img src={logo} alt="logo" /></div>
        <div className="line-wrapper">
            <div className="line"></div>
          </div>
          <div className="h3message">Inscris toi sur notre site StudentBank pour pouvoir profiter de nos services afin que nous puissions t'accompagner
pour tes projets futurs !</div>
            
            <div className="container" >
           
            <form onSubmit={sendEmail}>
                    <div className="row pt-5 mx-auto">
                    <div className="identity">IDENTITÉ</div>
                        <div className="spacing"></div>
                        <div className="arrageing">

                        <div class="col-6 form-group pt-2 mx-auto">
    
    <input type="text" class="form-control" name="name"  placeholder="Nom" required/>
  </div>
                        </div>
                        <div className="arrageing">               
    <div class="col-6 form-group pt-2 mx-auto">
      
      <input type="text" class="form-control" name="prename"  placeholder="Prénom" required/>
    </div>
    </div>      
                        
                       
                       
                      
    <div className="arrageing">  
                        <div className="col-6 form-group pt-2 mx-auto">
                            <input type="text" 
                    minlength="6" maxlength="10" className="form-control"  placeholder="Numéro de Téléphone" name="message"  required></input>
                        </div> </div>   
                        <div className="arrageing">  
                        <div className="col-6 form-group pt-2 mx-auto">
                            <input type="email" className="form-control" placeholder="Addresse Email" name="emailop" required/>
                        </div></div>
                        <div className="arrageing"> 
                        <div className="col-6 form-group pt-2 mx-auto">
                            <input type="text" className="form-control" placeholder="École" name="subject"  required/>
                        </div></div>
                        
                        
                        
                        
                       
                        <div className="putinplace"> 
                        <div className="col-10 pt-5 mx-auto" >
                            <input type="submit" className="btn btn-warning"  value="S'inscrire" ></input>
                        </div></div>
                       
                        
                    </div>
                </form>
            </div>
        </div>
    )
}